export default function DeliveryTime({ data }) {
  const productRecord = data?.productRecord;
  const isOversea = data?.isOversea;

  const localTime = () => {
    if (productRecord?.selfProductCode) {
      // P转C
      return <span className="text-[#69788A] text-[14px]">订货{productRecord?.deliveryTimeWayDays}</span>;
    } else if (data?.isSecondKill) {
      // 秒杀
      return (
        <span className="text-[#69788A] text-[14px]">
          结束后{data?.secondKillProductVO?.productDeliveryDay - 1}-{data?.secondKillProductVO?.productDeliveryDay + 1}
          工作日
        </span>
      );
    } else if (data?.isGroupProduct) {
      // 团购
      return (
        <span className="text-[#69788A] text-[14px]">
          支付后{data?.groupActivityProductVO?.productDeliveryDay - 1}-
          {data?.groupActivityProductVO?.productDeliveryDay + 1}工作日
        </span>
      );
    } else if (productRecord?.productStockStatus !== 'no') {
      // 现货
      return <span className="text-[#69788A] text-[14px]">现货最快4小时发货</span>;
    }
  };

  const overseaTime = (
    <>
      <span>{productRecord?.deliveryTimeWayDays}</span>
    </>
  );

  return (
    <>
      {(productRecord?.selfProductCode || data?.isSecondKill || productRecord?.deliveryTimeWayDays) && (
        <div>
          <h3 className="mt-[16px] text-[#020202] w-[100%] text-[14px] font-bold not-italic mb-[8px]">交货周期</h3>
          {isOversea ? overseaTime : localTime()}
        </div>
      )}
    </>
  );
}
